/* ==========================================================================
   LAUVEE - Selecteur de quantite du tiroir panier (refonte 2026)
   Styles dans assets/lauvee-cart.css.

   CE QU'ON FAIT :
   le tiroir de Dawn affiche un stepper (- 1 +) de 142 x 47px. Respire utilise
   un menu deroulant de 59 x 41px. On ajoute ce menu et on masque le stepper.

   POURQUOI EN JAVASCRIPT ET PAS EN LIQUID :
   le markup est ecrit en dur dans snippets/cart-drawer.liquid (29 Ko), un
   fichier du theme qu'on ne veut pas reprendre en entier.

   POURQUOI ON NE REMPLACE PAS LE <quantity-input> :
   premiere version tentee, elle ne mettait pas le panier a jour. Le champ est
   entoure de deux composants de Dawn - <quantity-input> et <quantity-popover>
   - et le gestionnaire de <cart-drawer-items> lit sur event.target des
   attributs que seul le champ d'origine porte (data-min, max, step, id...).
   On laisse donc tout le markup du theme en place, simplement masque, et le
   menu se contente d'ecrire dans le champ puis de declencher son evenement
   change : pour Dawn, c'est comme si le client avait tape la quantite.

   L'evenement change du menu est stoppe net (stopPropagation) : sans ca il
   remonterait jusqu'a <cart-drawer-items>, qui le traiterait avec le menu
   comme cible - exactement le bug de la premiere version.

   Dawn rerend le tiroir a chaque changement de quantite, ce qui ramene le
   markup d'origine : un MutationObserver refait donc l'ajout. L'attribut
   data-lv-qty evite de decorer deux fois le meme champ.
   ========================================================================== */

(function () {
  'use strict';

  // Nombre d'entrees proposees. Au-dela, le client passe par la page panier.
  var MAX_OPTIONS = 10;

  var CHEVRON =
    '<svg class="lv-qty__chevron" viewBox="0 0 12 7" fill="none" aria-hidden="true">' +
    '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function decorate(host) {
    if (host.dataset.lvQty) return;

    var input = host.querySelector('.quantity__input');
    if (!input) return;

    host.dataset.lvQty = '1';

    var current = parseInt(input.value, 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var limit = Math.max(MAX_OPTIONS, current);
    if (max && max < limit) limit = Math.max(max, current);

    // Pas de name ni d'id : ils restent au champ d'origine, qui est celui que
    // Dawn lit et auquel il rend le focus apres la mise a jour.
    var select = document.createElement('select');
    select.className = 'lv-qty__select';
    select.setAttribute(
      'aria-label',
      input.getAttribute('aria-label') || 'Quantite'
    );

    for (var i = 1; i <= limit; i++) {
      var option = document.createElement('option');
      option.value = String(i);
      option.textContent = String(i);
      select.appendChild(option);
    }
    select.value = String(current);

    var face = document.createElement('span');
    face.className = 'lv-qty__face';
    face.setAttribute('aria-hidden', 'true');
    face.innerHTML = '<span class="lv-qty__value">' + current + '</span>' + CHEVRON;

    select.addEventListener('change', function (event) {
      event.stopPropagation();

      var value = face.querySelector('.lv-qty__value');
      if (value) value.textContent = select.value;

      input.value = select.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'lv-qty';
    wrapper.appendChild(select);
    wrapper.appendChild(face);

    host.parentNode.insertBefore(wrapper, host);
  }

  function decorateAll(root) {
    var hosts = root.querySelectorAll('quantity-input');
    for (var i = 0; i < hosts.length; i++) decorate(hosts[i]);
  }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    decorateAll(drawer);

    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      decorateAll(drawer);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
